import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { OptionsProvider } from './contexts/OptionsContext';
import { ErrorBoundary } from 'react-error-boundary';

const ErrorFallback = ({ error }) => (
  <div role="alert" style={{ padding: '20px', border: '2px solid red', margin: '20px', fontFamily: 'monospace', backgroundColor: '#fff0f0' }}>
    <h1 style={{ color: 'red' }}>ALERTA: O APLICATIVO QUEBROU</h1>
    <p>Ocorreu um erro inesperado. Esta é a mensagem capturada:</p>
    <hr style={{ margin: '20px 0' }} />
    <pre style={{ whiteSpace: 'pre-wrap', backgroundColor: '#fdd', padding: '10px', borderRadius: '5px' }}>
      {error.message}
    </pre>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <OptionsProvider>
        <App />
      </OptionsProvider>
    </ErrorBoundary>
  </React.StrictMode>
);